module.exports = __webpack_public_path__ + "media/bootstrap-icons/skip-forward-btn-fill-c9e8a555.svg";